export const state = {
  apiUrl: '',
  searchMobileOpened: false,
  searchTerm: '',
  suggested: [],
  suggestedProducts: [],
  suggestedClp: [],
  suggestedArticles: [],
  loading: false,
};

export const mutations = {
  setApiUrl(state, payload) {
    state.apiUrl = payload;
  },
  setSearchMobileOpened(state, payload) {
    state.searchMobileOpened = payload;
    if (!payload) {
      document.querySelector('.search-trigger').focus();
      return;
    }
    document.querySelector('.form__input').focus();
  },
  setScrollLocker(state) {
    if (state.searchMobileOpened && state.searchTerm.length >= 3) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }
  },
  setSearchTerm(state, payload) {
    state.searchTerm = payload;
  },
  setSuggestedQueries(state, payload) {
    state.suggested = payload.slice(0, 3);
  },
  setSuggestedProductsQueries(state, payload) {
    state.suggestedProducts = payload.slice(0, 3);
  },
  setSuggestedClpQueries(state, payload) {
    state.suggestedClp = payload.slice(0, 3);
  },
  setSuggestedArticlesQueries(state, payload) {
    state.suggestedArticles = payload.slice(0, 3);
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
};

export const actions = {
  setApiUrl({ commit }, payload) {
    commit('setApiUrl', payload);
  },
  setSearchMobileOpened({ commit }, payload) {
    commit('setSearchMobileOpened', payload);
    commit('setScrollLocker');
  },
  emptySearchTerm({ commit }) {
    if (!state.searchTerm.length) {
      return;
    }
    commit('setSearchTerm', '');
  },
  setSearchTerm({ commit }, payload) {
    commit('setSearchTerm', payload);
    commit('setScrollLocker');
  },
  setScrollLocker({ commit }) {
    commit('setScrollLocker');
  },
  fetchSuggestedQueries({ commit, state }) {
    if (!state.searchTerm.length || state.searchTerm.length < 3) {
      return;
    }

    commit('setLoading', true);
    commit('setScrollLocker');

    const parseJSON = response => response.json();

    fetch(state.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      credentials: 'same-origin',
      body: JSON.stringify({ searchTerm: state.searchTerm }),
    })
      .then(parseJSON)
      .then(data => {
        let loaded = false;
        if (data.suggested) {
          commit('setSuggestedQueries', data.suggested);
          loaded = true;
        }
        if (data.suggestedProducts) {
          commit('setSuggestedProductsQueries', data.suggestedProducts);
          loaded = true;
        }
        if (data.suggestedClp) {
          commit('setSuggestedClpQueries', data.suggestedClp);
          loaded = true;
        }
        if (data.suggestedArticles) {
          commit('setSuggestedArticlesQueries', data.suggestedArticles);
          loaded = true;
        }
        if (loaded) {
          commit('setLoading', false);
        }
      })
      .catch(error => {
        commit('setSuggestedQueries', []);
        commit('setSuggestedProductsQueries', []);
        commit('setSuggestedClpQueries', []);
        commit('setSuggestedArticlesQueries', []);
        commit('setLoading', false);
        console.error('Could not load results', error); // eslint-disable-line no-console
      });
  },
  submitSearch({ state }) {
    if (!state.searchTerm.length) {
      return;
    }

    const parseJSON = response => response.json();

    fetch(state.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      credentials: 'same-origin',
      body: JSON.stringify({ searchTerm: state.searchTerm }),
    })
      .then(parseJSON)
      .then(data => {
        window.location = data.searchUrl;
      })
      .catch(error => {
        console.error('Could not load results', error); // eslint-disable-line no-console
      });
  },
};
export const getters = {
  searchMobileOpened: state => state.searchMobileOpened,
  searchTerm: state => state.searchTerm,
  suggested: state => state.suggested,
  suggestedProducts: state => state.suggestedProducts,
  suggestedClp: state => state.suggestedClp,
  suggestedArticles: state => state.suggestedArticles,
  loading: state => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
